__turbopack_context__.v({
  "actionLink": "NotificationFooter-module-scss-module__VQ-ddq__actionLink",
  "details": "NotificationFooter-module-scss-module__VQ-ddq__details",
  "root": "NotificationFooter-module-scss-module__VQ-ddq__root",
});
